class CacheService {
	private static instance: CacheService;

	constructor() {
		if (CacheService.instance) {
			return CacheService.instance;
		}

		CacheService.instance = this;
		return this;
	}

	get<T>(key: string): T {
		const savedValue = localStorage.getItem(key);
		if (!savedValue) {
			return null;
		}

		const parsedValue = JSON.parse(savedValue);
		if (parsedValue.expireTime && Date.now() > parsedValue.expireTime) {
			return null;
		}

		return parsedValue.value;
	}

	set(key: string, value: unknown, expire?: number) {
		const expireTime = expire ? Date.now() + expire : null;

		localStorage.setItem(
			key,
			JSON.stringify({
				value,
				expireTime,
			}),
		);
	}
}

export const cacheService = new CacheService();
